




















































import Vue from 'vue'
import CsvImportTile from '@/components/CsvImportTile.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { CsvImportTile },
    computed: {
        ...mapGetters(['importOptions']),
        matchedFields() {
            //  Get all import options
            const options = this.importOptions

            //  Grab all of our fields that have been set
            const setFields = options.filter((x) => x.csvField != null)

            //  We only want the csvField value for each
            return setFields.map((x) => x.csvField)
        },
        phoneIsMatched(): boolean {
            //  Get all importOptions
            const options = this.importOptions

            //  Set valid bool
            let phone = false

            //  Iterate through importOptions, if item is Phone Number and is matched, set bool
            options.forEach((item) => {
                if (item.sdkField.name === 'Phone Number' && item.csvField) {
                    phone = true
                }
            })

            //  Return bool
            return phone
        }
    },
    methods: {
        back(): void {
            this.$emit('back')
        },
        next(): void {
            //  Phone number is required to be matched
            // if (!this.phoneIsMatched) {
            //     return this.$store.dispatch('dialogOpen', {
            //         type: 'MESSAGE',
            //         title: 'Error',
            //         icon: 'mdi-alert',
            //         color: 'primary',
            //         text: "You must match a field to 'Phone Number' in order to continue."
            //     })
            // }

            //  Filter out options that are not matched
            const matched = this.importOptions.filter(
                (option) => option.csvField !== null
            )

            //  Set importMatched
            this.$store.commit('importMatchedSet', matched)

            //  Go to CsvImportStepFour
            this.$emit('next')
        },
        matchedHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Matched Data Field',
                text: 'A matched data field matches a column from the .csv file you are attempting to import into MessageDesk. Non-matched fields will not be imported.',
                color: 'primary',
                icon: 'mdi-help-circle'
            })
        },
        messagedeskFieldHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'MessageDesk Data Field',
                text: 'MessageDesk data fields are fields that are already present and available in MessageDesk. These include MessageDesk custom fields as well.',
                color: 'primary',
                icon: 'mdi-help-circle'
            })
        },
        resetTile(uuid: string): void {
            //  Find the tile with this uuid
            const tiles = this.$refs[uuid]

            //  If no tile was found, do nothing
            if (!tiles) return

            //  Our refs are in array format so we need to call it on each entry
            for (const tile of tiles) tile.reset()
        }
    }
})
